import React, { createContext } from 'react';
import { defaultCurrency, Currency } from '../hooks/useCurrencies';

type Props = {
  children: React.ReactNode;
  selectedCurrency: Currency;
};

export const CurrencyContext = createContext<Currency>(defaultCurrency);

export const CurrencyProvider = ({ children, selectedCurrency }: Props) => {
  return (
    <CurrencyContext.Provider value={selectedCurrency}>
      {children}
    </CurrencyContext.Provider>
  );
};
